import { PrimitiveCard } from './PrimitiveCard'
import { Transition } from '@headlessui/react'
import { useEffect, useState } from 'react'
import {
    PlayIcon,
  PlusIcon as PlusIconOutline,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { HeroIcon } from './HeroIcon'
import ConfirmationPopup from "./ConfirmationPopup";
import MainStore from './MainStore'
import Panel from './Panel'
import PrimitiveConfig from './PrimitiveConfig'
import PrimitivePicker from './PrimitivePicker'
import { VFImage } from './VFImage'
import useDataEvent from './CustomHook'
import CardGrid from './CardGrid'
import { InputPopup } from './InputPopup'
import QueryCard from './QueryCard'
import SummaryCard from './SummaryCard'
import { Table } from './Table'
import { FlowContent } from './sidebar/FlowContent'
import AgentChat from './AgentChat'
import clsx from 'clsx'
import CustomFieldsEditor from './CustomFieldsEditor'
import { Select, SelectItem } from '@heroui/react'



export function Sidebar({primitive, ...props}) {
    const [manualInputPrompt, setManualInputPrompt] = useState(false)
    const [showDeletePrompt, setShowDeletePrompt] = useState(false)
    const [showUnlinkPrompt, setShowUnlinkPrompt] = useState(false)
    const [showLink, setShowLink] = useState(false)
    const [fulltext, setFullText] = useState()
    
    useDataEvent('set_field relationship_update', Array.isArray(primitive) ?  primitive.map(d=>d?.id) : primitive?.id )

    let infoPane = props.infoPane
    let isMulti = false
    let commonMultiType 
    
    if( Array.isArray(primitive) ){
        if(primitive.length === 1){
            primitive = primitive[0]
        }else{
            primitive = primitive.map((d)=> d instanceof Object ? d : MainStore().primitive(d)).filter((d)=>d)
            isMulti = true
        }
    }
    if( primitive && !(primitive instanceof Object) ){
        primitive = MainStore().primitive(primitive)
    }

    useEffect(()=>{
        setFullText()
    }, [primitive?.id, isMulti])

    if( primitive === undefined ){
        return(<></>)
    }
    let metadata = primitive.metadata
    let task = primitive.originTask
    let origin = task && (primitive.originId !== task.id) ? primitive.origin : undefined
    let showSource = metadata?.sidebar?.showSource ?? PrimitiveConfig.sidebar[primitive.type]?.source ?? true
    let showAddToResult = metadata?.sidebar?.addToResult ?? PrimitiveConfig.sidebar[primitive.type]?.addToResult ?? false



    const promptDelete = ( deleteNested )=>{
        let nestedPrompt = deleteNested ? `, and ${nestedCount} nested items.\nWARNING: This will removed nested items entirely, not just from this itemt` : ""
        if( isMulti ){
            setShowDeletePrompt( {prompt: `Are you sure you want to remove ${primitive.length} items${nestedPrompt}`, deleteNested: deleteNested} )
        }else{

            setShowDeletePrompt( {prompt: `Are you sure you want to remove ${primitive.displayType} #${primitive.plainId}${nestedPrompt}`, deleteNested: deleteNested} )
        }
     // setPrimitive(null)
    }

    const handleDelete = async ()=>{
        
        if( isMulti ){
            for( const p of primitive ){
                if( showDeletePrompt.deleteNested ){
                    await p.removeChildren(true)
                }
                await MainStore().removePrimitive( p )
            }
        }else{
            if( showDeletePrompt.deleteNested ){
                await primitive.removeChildren(true)
            }
            MainStore().removePrimitive( primitive )
        }
      setShowDeletePrompt( null )
      props.setOpen(false)
    }

    const linkTo = async (picked)=>{
        const list = isMulti ? primitive : [primitive]

        for( const p of list){
            if( picked.metadata && picked.metadata.resultCategories ){
                const target = picked.metadata.resultCategories.filter((d)=>d.resultCategoryId === p.referenceId)[0]
                let relationship
                if( target ){
                    relationship = `results.${target.id}`
                }else{
                    if( picked.metadata.resultCategories ){
                        relationship = `results.0`
                    }
                }
                if( relationship ){
                    console.log(`additng ${p.plainId} at ${relationship}`)
                    await picked.addRelationship(p, relationship)
                }
            }
            console.log(`cant add ${p.id} - no suitable result section`)
        }
    }
    
    let thisType = primitive.type
    if( isMulti ){
        const types = primitive.map((d)=>d.type).filter((v,i,a)=>a.indexOf(v)===i)
        commonMultiType = types.length === 1 ? types[0] : undefined
        thisType = commonMultiType
    }

    let resultIds = metadata?.sidebar?.addToItems ?? PrimitiveConfig.sidebar[thisType]?.addToItems
    if(resultIds){
        showAddToResult = resultIds.length > 1 ? "item" : MainStore().category( resultIds[0] )?.title
    }else{
        resultIds = [primitive.referenceId]
        if( isMulti ){
            showAddToResult = metadata?.sidebar?.addToResult ?? PrimitiveConfig.sidebar[commonMultiType]?.addToResult ?? false 
            resultIds = primitive.map((d)=>d.referenceId).filter((v,i,a)=>a.indexOf(v)===i)
        }
    }
    let showButtons = !isMulti || (isMulti && commonMultiType)
    let showUnlinkFromScope = false 

    if( props.scope ){
        showUnlinkFromScope = true
        const list = isMulti ? primitive : [primitive]
        for( const p of list){
            console.log(`check`, props.scope, p, p.origin?.id === props.scope.id, !p.parentPaths( props.scope ))
            if( p.origin?.id === props.scope.id || !p.parentPaths( props.scope )){
                showUnlinkFromScope = false
            }
        }
    }
    let unlinkText = showUnlinkFromScope ? `${props.scope.metadata?.title} #${props.scope.plainId}` || props.scope.plainId : undefined

    const unlinkFromScope = async ()=>{
        const paths = primitive.parentPaths( props.scope ).filter((d)=>d !== 'origin')
        for(const path of paths){
            await props.scope.removeRelationship( primitive, path)
        }
        setShowUnlinkPrompt(false)
    }

    const nestedCount = props.allowRemoveChildren ? [primitive].flat().map(d=>d.primitives.allIds.length)?.reduce((a,c)=>a+c,0) : undefined
    let summaryList = (primitive.type === "view" && !infoPane) ? primitive.primitives.origin.allSegment.map(d=>d.primitives.allSummary).flat() : undefined

    let infoPaneContent 
    if( infoPane ){
        let segmentOriginId = primitive.id
        let allSegments = primitive.primitives.allSegment
        if( primitive.type === "query"){
            if( primitive.metadata.type === "aggregator"){
                const parentForScope = primitive.findParentPrimitives({type: "working"})[0]
                if( parentForScope ){
                    allSegments = parentForScope.primitives.allSegment
                    segmentOriginId = parentForScope.id
                }
            }
        }
        let segment = allSegments.find(d=>d.doesImport( segmentOriginId, infoPane.filters))
        if( segment ){
            summaryList = segment.primitives.origin.allSummary 
            console.log(`FOUND SEGEMNT `, segment.plainId, segment.itemsForProcessing.length)
        }
        let segmentCategory = primitive.metadata?.resultCategories?.find(d=>MainStore().category(d.resultCategoryId)?.primitiveType === "segment")?.resultCategoryId 

        const items = segment ? segment.itemsForProcessing : primitive.itemsForProcessingWithFilter(infoPane.filters)
        const categories = items.map(d=>d.referenceId).filter((d,i,a)=>a.indexOf(d) === i)
        if( categories.length === 1){
            console.log(`Single category of items selected ${categories[0]}`)
            const candidates = MainStore().categories().filter(d=>d.primitiveType === 'segment' && d.holds?.includes(categories[0]))
            if( candidates.length > 0){
                if( candidates.length > 1){
                    console.log(`Found ${candidates.length} candidate segments for items, picking first = ${candidates[0].id}`)
                }
                segmentCategory = candidates[0].id
            }
        }
        console.log(` Will created as ${segmentCategory}`)

        const addSegment = async ()=>{
            const newPrim = await MainStore().createPrimitive({
                title: "New Segment",
                type: "segment",
                categoryId: segmentCategory ?? 36,
                parent: primitive,
                referenceParameters:{
                    "target": "items",
                    "importConfig": [{filters: infoPane.filters,id: primitive.id}]
                }
            })
            console.log(newPrim)
            if( newPrim ){
                await newPrim.addRelationship(primitive, "imports")
            }
            return newPrim
        }
        
        const categoryType = items.map(d=>d.metadata).filter((d,i,a)=>d&& a.findIndex(d2=>d2.id==d.id) ===i)
        const nestedActions = categoryType.map(d=>d.actions?.filter(d=>d.collectionAction || d.showInCollection)).flat() ?? []
        const callbackProcessor = ()=>{}

        infoPaneContent = <div className='p-4 space-y-2'>
            <p className='text-lg'>{items.length} items</p>
            {segment && <>
                    {primitive.metadata?.actions && <div className='w-full flex'>
                        <PrimitiveCard.CardMenu primitive={segment}
                            custom={nestedActions.map(d=>{
                                return {
                                    ...d,
                                    action: async ()=>await MainStore().doPrimitiveAction( primitive, "auto_cascade", {cascade_key: d.key, ids: items?.map(d=>d.id)})
                                }
                            })}
                            buttonProps={{ variant: 'light', isIconOnly: true, size: 'sm', className: 'ml-auto m-2' }}
                        />
                    </div>}
                    <PrimitiveCard.SidePanel primitive={segment}/>
                </> 
            }
            {nestedActions.length > 0&& <PrimitiveCard.CardMenu
                            icon={<PlayIcon className="w-4 h-4 m-[0.45rem]"/>}
                            buttonProps={{ variant: 'light', isIconOnly: true, size: 'sm' }}
                            custom={nestedActions.map(d=>{
                                const doAction = async (options)=>{
                                    await MainStore().doPrimitiveAction( 
                                        d.collectionAction ? items[0] : primitive, 
                                        d.collectionAction ? d.key : "auto_cascade", 
                                        {cascade_key: d.collectionAction ?  undefined : d.key, ids: items?.map(d=>d.id), ...options},
                                        callbackProcessor
                                        )
                                }
                                return {
                                    ...d,
                                    action: async ()=>{
                                        if( d.actionFields){
                                            setManualInputPrompt({
                                                primitive: primitive,
                                                fields: d.actionFields,
                                                confirm: async (inputs)=>await doAction( inputs )
                                            })
                                        }else{
                                            await doAction()
                                        }

                                    }
                                }
                            })} 
                        />

            }
            {summaryList?.length > 0 && 
                <Panel title="Summaries" collapsable={true} open={true} major>
                    <CardGrid   
                        list={summaryList} 
                        className='p-2'
                        columnConfig={{"sm":1}}
                        cardProps={{
                            showDetails:"panel",
                            compact: true,
                            border:false,
                            showExpand: false,
                            titleAtBase: true, 
                            showMenu: true,
                            variant: true
                        }}
                    />
                </Panel>
            }
            {!segment && <button
                type="button"
                className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={addSegment}
                >
                Create as segment
            </button>}
            {!segment && <button
                type="button"
                className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={async ()=>{
                    setShowLink({
                        root: primitive.task,
                        exclude: [primitive],
                        resultCategoryId: primitive.referenceId,
                        callback: async (d)=>{
                            const newSegment = await addSegment()
                            await d.addRelationship( newSegment, "imports" )
                        }
                    })
                }}
                >
                    Create as segment and add to a different View
                </button>}
            {!segment && <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 "
                    onClick={()=>MainStore().promptDelete({
                        prompt: `Remove ${items.length} items from this segment?`,
                        handleDelete: async ()=>{
                            for(const d of items){
                                await MainStore().removePrimitive( d )
                            }
                        }
                    })}
                >
                    Delete items
            </button>}
            {segment && <button
                type="button"
                className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={async ()=>{
                    setShowLink({
                        root: primitive.task,
                        exclude: [primitive],
                        resultCategoryId: primitive.referenceId,
                        callback: (d)=>{
                            d.addRelationship( segment, "imports" )
                        }
                    })
                }}
                >
                    Add segment to a different View
                </button>}
        </div>
    }

    const showAsSummary = primitive.type === "summary" || (primitive.type === "segment" && primitive.referenceParameters.summary)

    let rationaleList = <></>
    if( (primitive.type === "result" || primitive.type === "entity" || primitive.type === "summary")){
        const categoryParents = primitive.parentPrimitives.filter(d=>d.type === "category")
        if( categoryParents.length > 0){
            const mainstore = MainStore()

            const handleCategorySwitch = async (oldCatId, newCatId) => {
                const oldCat = mainstore.primitive(oldCatId)
                const newCat = mainstore.primitive(newCatId)
                if(!oldCat || !newCat) return
                oldCat.removeRelationship(primitive, "ref")
                newCat.addRelationship(primitive, "ref")
            }

            rationaleList = 
            <Panel title="Categories" collapsable={true} open={false} major>
                <div className='w-full overflow-x-auto'>
                    <table className='w-full text-xs border-collapse'>
                        <thead>
                            <tr className='border-b border-gray-200'>
                                <th className='text-left p-2 font-semibold text-gray-500'>Parent</th>
                                <th className='text-left p-2 font-semibold text-gray-500'>Category</th>
                                <th className='text-left p-2 font-semibold text-gray-500'>Rationale</th>
                                <th className='text-left p-2 font-semibold text-gray-500'>Switch</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categoryParents.map((catParent, idx) => {
                                const parentCat = catParent.origin
                                const peers = parentCat?.type === "category"
                                    ? (parentCat.primitives?.origin?.allItems ?? []).filter(
                                        c => c && c.type === "category" && c.id !== catParent.id
                                      )
                                    : []
                                const hasPeers = peers.length > 0
                                return (
                                    <tr key={idx} className='border-b border-gray-100 hover:bg-gray-50'>
                                        <td className='p-2 text-gray-600'>{catParent.origin?.title ?? "Unknown"}</td>
                                        <td className='p-2 font-medium text-gray-800'>{catParent.title}</td>
                                        <td className='p-2 text-gray-600 max-w-[12em] truncate' title={catParent.rationale?.[primitive.id] ?? ""}>{catParent.rationale?.[primitive.id] ?? ""}</td>
                                        <td className='p-2'>
                                            {hasPeers ? (
                                                <Select
                                                    size="sm"
                                                    variant="bordered"
                                                    selectedKeys={[String(catParent.id)]}
                                                    disallowEmptySelection
                                                    className='min-w-[150px]'
                                                    classNames={{
                                                        trigger: "min-h-unit-8 h-unit-8",
                                                    }}
                                                    onSelectionChange={(keys) => {
                                                        const nextKey = Array.from(keys)[0]
                                                        if(!nextKey || nextKey === String(catParent.id)) return
                                                        handleCategorySwitch(catParent.id, nextKey)
                                                    }}
                                                    renderValue={() => <span>{catParent.title}</span>}
                                                >
                                                    <SelectItem key={String(catParent.id)} textValue={catParent.title}>{catParent.title} (current)</SelectItem>
                                                    {peers.map(peer => (
                                                        <SelectItem key={String(peer.id)} textValue={peer.title}>{peer.title}</SelectItem>
                                                    ))}
                                                </Select>
                                            ) : (
                                                <span className='text-xs text-gray-400'>No peers</span>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </Panel>
        }
    }

    let sidebarContent
    if( props.forFlow ){
        sidebarContent = <div className='flex p-2 w-full bg-white dark:bg-slate-950 dark:text-slate-100'>
            <FlowContent primitives={isMulti ? primitive : [primitive]} {...props} />
            </div>
    }else{
        sidebarContent = <div className="space-y-2 bg-white dark:bg-slate-950 dark:text-slate-100">
        {infoPane && infoPaneContent}
            {!infoPane && isMulti && !commonMultiType && <div className="pb-2 pl-4 pr-4 pt-4">Cant inspect selection</div> }            
            {!infoPane && isMulti && commonMultiType && <div className="pb-2 pl-4 pr-4 pt-4">{primitive.length} items selected</div> }
            {!infoPane && !props.forFlow && !isMulti && (primitive.avatarImageUrl || primitive.metadata?.actions) && <div className='w-full flex'>
                {primitive.avatarImageUrl && (
                    <VFImage
                        className="w-8 h-8 mx-2 object-contain my-auto"
                        src={primitive.avatarImageUrl}
                    />
                )}
                {primitive.metadata?.actions && 
                    <div className='ml-auto'>
                        <PrimitiveCard.CardMenu primitive={primitive} buttonProps={{ variant: 'light', isIconOnly: true, size: 'sm' }} />
                        </div>}
            </div>}
            {!infoPane && !isMulti && !props.forFlow && primitive.type === "query" && <div className="pb-2 pl-4 pr-4 pt-4">
                <QueryCard primitive={primitive} showDetails={true}/>
            </div>}
            {!infoPane && !isMulti && showAsSummary && <div className="pb-2 pl-4 pr-4 pt-4">
                {
                    primitive.getConfig.chat && <Panel title="Chat about this data" collapsable={true} open={true} major>
                        <div className='flex flex-col max-h-[80vh] rounded-lg border-2 border-ccgreen-600 p-4 text-sm'>
                            <AgentChat primitive={primitive} mode="refining"/>
                        </div>
                    </Panel>
                }
                <SummaryCard primitive={primitive} showDetails={true}/>
                {rationaleList}
            </div>}
            {!infoPane && !isMulti && props.forFlow && <div className="pb-2 pl-4 pr-4 pt-4 " >
                <span className="text-2xl font-bold text-gray-500">{primitive.configParent?.title}</span>
                <PrimitiveCard.Title primitive={primitive.configParent}/>
                <div className='my-5 flex flex-col'>
                    {!props.asList && <>
                            <p className="text-sm font-bold text-gray-500">Step instance details</p>
                            <div className='border border-gray-200 rounded-md p-2 bg-gray-50 my-3 dark:border-gray-700 dark:bg-gray-800'>
                                <PrimitiveCard.OutputPins primitive={primitive}/>
                            </div>
                    </>}
                    {props.asList &&<Table
                                        primitive={primitive}
                                        page={0}
                                        pageItems={50}
                                        onEnter={(d)=>MainStore().sidebarSelect(d)}
                                        columns={[
                                            {field: 'plainId', title: "ID", width: 80},
                                            {field: 'title', title: "Title"},
                                        ]}
                                        data={props.list} 
                                        className='w-full min-h-[24em] max-h-[60vh] !text-xs'/>}
                    <PrimitiveCard.Title primitive={primitive}/>
                </div>
                <button
                    type="button"
                    className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:ring-slate-400"
                    onClick={()=>{
                        const flowInstance = primitive.findParentPrimitives({type: ["flowinstance"]})[0]
                        MainStore().doPrimitiveAction( flowInstance, "run_flowinstance_from_step", {from: primitive.id, force: true})
                        
                    }}
                >
                    Run from here
                </button>
            </div>}
            {!infoPane && !isMulti && !props.forFlow && !showAsSummary && primitive.type !== "query" && <div className="pb-2 pl-4 pr-4 pt-4">
                <PrimitiveCard.SidePanel primitive={primitive} showQuote editState={primitive.type==="hypothesis"}/>
                {rationaleList}
                {primitive.metadata?.extendable && <CustomFieldsEditor primitive={primitive} />}
                {primitive.type === "result" && !fulltext && (primitive.referenceParameters?.url || primitive.referenceParameters?.notes || primitive.referenceParameters?.integrationAttachments) && <Panel.MenuButton title='View text' onClick={async ()=>setFullText((await primitive.getDocumentAsText())?.split(" ").slice(0,5000).join(" "))}/>}
                {primitive.type === "result" && fulltext && <div className='p-3 border border-gray-200 rounded-md text-sm bg-white dark:border-gray-700 dark:bg-gray-800'>{fulltext}</div>}
                {summaryList?.length > 0 && 
                    <Panel title="Summaries" collapsable={true} open={true} major>
                        <CardGrid   
                            list={summaryList} 
                            className='p-2'
                            columnConfig={{"sm":1}}
                            cardProps={{
                                showDetails:"panel",
                                compact: true,
                                border:false,
                                showExpand: false,
                                titleAtBase: true, 
                                showMenu: true,
                                variant: true
                            }}
                        />
                    </Panel>
                }
                {primitive.primitives.allUniqueEvidence.length > 0 && 
                    <Panel title="Evidence" collapsable={true} open={true} major>
                        <PrimitiveCard.EvidenceList primitive={primitive} hideTitle relationshipMode="none"/>
                    </Panel>
                }

                {primitive.primitives.results?.[0].allIds.length > 0 && 
                    <Panel title={primitive.metadata?.resultCategories?.find(d=>d.id === 0)?.title ?? "Items"} collapsable={true} open={true} major>
                        <CardGrid   
                            list={primitive.primitives.results[0].allItems} 
                            className='p-2'
                            columnConfig={{"sm":1}}
                            cardProps={{
                                showDetails:"panel",
                                compact: true,
                                border:false,
                                showExpand: false,
                                titleAtBase: true, 
                                showMenu: true
                            }}
                        />
                    </Panel>
                }
                {primitive.parentPrimitiveRelationships["link"] && showSource &&
                    <div className='mt-6 mb-3 border-t'>
                        <h3 className="mb-2 text-md text-gray-400 pt-2">Linked to</h3>
                        <PrimitiveCard.PanelReference primitive={primitive.parentPrimitiveRelationships["link"][0]}/>
                    </div>
                }
                {origin && showSource &&
                    <div className='mt-6 mb-3 border-t'>
                        <h3 className="mb-2 text-md text-gray-400 pt-2">Source</h3>
                        <PrimitiveCard.PanelReference primitive={origin.type === "search" ? origin.origin : origin}/>
                    </div>
                }
                {task && <div className='mt-6 mb-3 border-t'>
                    <h3 className="mb-2 text-md text-gray-400  pt-2">Related {task.type}</h3>
                    <PrimitiveCard.PanelReference primitive={task} showUsers="panel"/>
                </div>}
            </div>}
            {(metadata?.sidebar?.showRefs || PrimitiveConfig.sidebar[primitive.type]?.showRefs) && (primitive.primitives.ref?.allIds.length + primitive.primitives.link?.allIds.length + primitive.primitives.source?.allIds.length)> 0 && 
                <div className="pb-2 pl-4 pr-4 pt-4">
                    <Panel title="References" collapsable={true} open={true} major>
                        <CardGrid   
                            list={MainStore().uniquePrimitives( [...primitive.primitives.ref.allItems, ...primitive.primitives.link.allItems, ...primitive.primitives.source.allItems])} 
                            className='p-2'
                            columnConfig={{"sm":1}}
                            cardProps={{
                                showDetails:"panel",
                                compact: true,
                                border:false,
                                showExpand: false,
                                titleAtBase: true, 
                                showMenu: true
                            }}
                        />
                    </Panel>
                </div>
            }
            {!infoPane && showButtons && <div className="flex-shrink-0 justify-between space-y-2 p-4 mt-1">
                {showUnlinkFromScope && <button
                    type="button"
                    className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:ring-slate-400"
                    onClick={()=>setShowUnlinkPrompt(`Unlink from ${unlinkText}?`)}
                >
                    Unlink from {unlinkText}
                </button>}
                { showAddToResult && <button
                    type="button"
                    className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:ring-slate-400"
                    onClick={()=>setShowLink(true)}
                >
                    Link {isMulti ? `${primitive.length} items ` : ""}to another {typeof(showAddToResult) === "string" ? showAddToResult : "result"}
                </button>}
                {props.unlink && <button
                    type="button"
                    className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:ring-slate-400"
                    onClick={()=>{props.unlink(primitive);props.setOpen(false)}}
                >
                    Remove from {props.unlinkText ? props.unlinkText : 'item'}
                </button>}
                    {primitive.type === "segment" && <button
                        type="button"
                        className="w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:focus:ring-slate-400"
                        onClick={async ()=>{
                            await MainStore().createPrimitive({
                                title: "New Segment",
                                type: "segment",
                                categoryId: primitive.referenceId,
                                parent: primitive
                            })
                        }}
                    >
                        Create sub segment
                </button>}
                {nestedCount > 0 && props.allowRemoveChildren && <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 "
                    onClick={()=>promptDelete(true)}
                >
                    {(isMulti ? `Delete ${primitive.length} items` : 'Delete this') + ` and ${nestedCount} nested items`}
                </button>}
                {!props.forFlow && <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 "
                    onClick={()=>promptDelete()}
                >
                    {isMulti ? `Delete ${primitive.length} items` : 'Delete'}
                </button>}
            </div>}
        </div>

    }
    

    return (
        <>
    {manualInputPrompt && <InputPopup key='input' cancel={()=>setManualInputPrompt(false)} {...manualInputPrompt}/>}
    {!infoPane && showLink && <PrimitivePicker target={isMulti ? primitive : [primitive]} root={isMulti ? primitive[0].task : primitive.task} path='results' callback={linkTo} setOpen={setShowLink} referenceId={resultIds} />}
    {infoPane && showLink && <PrimitivePicker setOpen={setShowLink} {...showLink} />}
    {showUnlinkPrompt && <ConfirmationPopup title="Confirm unlink" message={showUnlinkPrompt} confirmColor='indigo' confirmText='Unlink' confirm={unlinkFromScope} cancel={()=>setShowUnlinkPrompt(false)}/>}
    {showDeletePrompt && <ConfirmationPopup title="Confirm deletion" message={showDeletePrompt.prompt} confirm={handleDelete} cancel={()=>setShowDeletePrompt(false)}/>}
    <Transition.Root 
            show={props.open}
            appear={true}
            as='aside'
            enter="transition-[min-width,width] ease-in-out duration-[200ms]"
            leave="transition-[min-width,width] ease-in-out duration-[200ms] "
            enterFrom="min-w-0 w-0"
            enterTo="min-w-[24rem] sm:min-w-[28rem] w-[24rem] sm:w-[28rem] 4xl:min-w-[40rem] 4xl:w-[40rem] 6xl:min-w-[48rem] 6xl:w-[48rem] "
            leaveFrom="min-w-[24rem] sm:min-w-[28rem] w-[24rem] sm:w-[28rem] 4xl:min-w-[40rem] 4xl:w-[40rem] 6xl:min-w-[48rem] 6xl:w-[48rem] "
            leaveTo="min-w-0 w-0"
            className={clsx(
                `absolute right-0 z-50 h-screen overflow-y-auto border-l border-gray-200 bg-white max-h-screen shadow-2xl dark:border-gray-800 dark:bg-slate-950`,
                props.fixed ? `4xl:relative 4xl:shadow-none` : ""
            )}>
        <div className='min-w-max @container'>
        <div className='max-w-[24rem] sm:max-w-[28rem] 4xl:min-w-[40rem] 6xl:min-w-[48rem]'>
            <div className="border-b-gray-100 px-4 py-4 shadow-md  sticky z-50 top-0 bg-white dark:border-gray-800 dark:bg-gray-900">
                <div className="flex items-start justify-between space-x-3">
                    {metadata && <div className='flex place-items-center'>
                        <HeroIcon icon={metadata.icon} className='w-20 h-20'/>
                        <div className='ml-2'>
                            <p className="text-2xl font-bold text-gray-600 dark:text-gray-100">{isMulti ? primitive.length + " items" : (primitive.inFlow ? (primitive.configParent ?? primitive).title : primitive.title)}</p>
                            {isMulti && <p className="text-md text-gray-500 dark:text-gray-300">{metadata.title}</p>}
                            {!isMulti && <PrimitiveCard.Title primitive={(primitive.inFlow ? primitive.configParent ?? primitive : primitive)}/>}
                        </div>
                    </div>}
                    <div className="flex h-7 items-center">
                        <button
                            type="button"
                            className="text-gray-400 hover:text-gray-500 dark:text-slate-400 dark:hover:text-white"
                            onClick={() => props.setOpen(false)}
                        >
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
            {sidebarContent}
            
    </div>
    </div>
    </Transition.Root>
        </>
    )
}
